export default (str, replaceNewLine) => {
  let newStr = str;
  if (replaceNewLine) {
    newStr = newStr.replace(/<br \/>/g, '\n').trim();
  }
  return newStr.replace(/</g, '&lt;').replace(/>/g, '&gt;').trim();
};



// WEBPACK FOOTER //
// ./src/utils/removeTag.js